import React from 'react';
import { Navigate } from 'react-router-dom';
import { useStore } from '@betgames/bg-state-manager';
import { TwainGameId } from 'betgames-contract-js';
import { auth, authSelectors } from 'store/Auth';
import { gameMessage } from 'store/GameMessage';
import { IMessage } from 'store/GameMessage/interfaces/IMessage';
import { MessageType } from 'store/GameMessage/enums/MessageType';
import { routes } from 'utils/routes';

interface IProps {
    children: JSX.Element;
}

const authenticationMessage: IMessage = {
    text: 'please_login',
    type: MessageType.WARNING,
};

export const AuthProtection = (props: IProps) => {
    const isAuthenticated = useStore(auth.store, authSelectors.isAuthenticated);

    React.useEffect(() => {
        if (!isAuthenticated) {
            gameMessage.store.add(authenticationMessage);
        }
    }, [isAuthenticated]);

    if (!isAuthenticated) {
        return <Navigate to={routes.game(TwainGameId.RNG_T_KICK).current} replace />;
    }

    return props.children;
};
